import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const ROOT = `${API_BASE_URL}/api/untraceable-cases`;

// `employeeId` is only needed when an admin acts on someone else's list.
export const getUntraceableCasesApi = ({ employeeId, status } = {}) =>
  axios.get(ROOT, { params: { employeeId, status } });

export const getUntraceableSummaryApi = (employeeId) =>
  axios.get(`${ROOT}/summary`, { params: { employeeId } });

// { employeeId?, customerName, phone }
export const createUntraceableCaseApi = (payload) => axios.post(ROOT, payload);

// { employeeId?, customerName?, phone? }
export const updateUntraceableCaseApi = (id, payload) =>
  axios.put(`${ROOT}/${id}`, payload);

// { employeeId?, text, date? }
export const addUntraceableRemarkApi = (id, payload) =>
  axios.put(`${ROOT}/${id}/remark`, payload);

// { employeeId?, note? }
export const closeUntraceableCaseApi = (id, payload) =>
  axios.put(`${ROOT}/${id}/close`, payload);

export const reopenUntraceableCaseApi = (id, payload) =>
  axios.put(`${ROOT}/${id}/reopen`, payload);

export const deleteUntraceableCaseApi = (id, employeeId) =>
  axios.delete(`${ROOT}/${id}`, { params: { employeeId } });
